<template>

  <div class="graph">
    <div class="graph__title">
      Причины отказов
    </div>
    <div v-if="items?.length > 0" class="graph__content">
      <div class="graph__legend">
        <div class="title flex space-between">
          <div style="color: #566A83!important;">Причина</div>
          <div>Сумма/Доля</div>
        </div>
        <div class="item flex space-between vertical-center" v-for="item in data" :key="item.id">
          <div class="flex ">
            <div :style="{backgroundColor: getBgColor(item.title)}" class="bg"></div>
            <div style="color: #1E3959">{{item.title}}</div>
          </div>
          <div class="flex">
            <div style="color: #1E3959" class="bold">{{formatNum(item.count)}}</div>
            <div style="color: #8F9CAC">&nbsp;({{formatNum(item.share)}}%)</div>
          </div>
        </div>
      </div>
      <div  class="graph__graph">
        <canvas ref="doughnutChart"></canvas>
        <div class="graph__total">
          <div class="title">Всего</div>
          <div class="count">{{total? total : 520}}</div>
        </div>
      </div>
    </div>
    <div v-else class="flex gap-8">
      <div style="width: 515px; margin-top: 8px;">
        <div class="title flex space-between">
          <div style="color: #566A83!important;">Причина</div>
          <div>Сумма/Доля</div>
        </div>
        <div style="height: 330px" class="no-data" >
          Нет данных
        </div>
      </div>
      <div style="margin-top: 76px;" class="">
        <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M240 120C240 186.274 186.274 240 120 240C53.7258 240 0 186.274 0 120C0 53.7258 53.7258 0 120 0C186.274 0 240 53.7258 240 120ZM18 120C18 176.333 63.667 222 120 222C176.333 222 222 176.333 222 120C222 63.667 176.333 18 120 18C63.667 18 18 63.667 18 120Z" fill="#E4E7EE"/>
          <path d="M101.233 98.5V88.3182H104.793C105.502 88.3182 106.087 88.4408 106.548 88.6861C107.008 88.928 107.351 89.2545 107.577 89.6655C107.802 90.0732 107.915 90.5256 107.915 91.0227C107.915 91.4602 107.837 91.8215 107.681 92.1065C107.529 92.3916 107.326 92.617 107.075 92.7827C106.826 92.9484 106.556 93.071 106.264 93.1506V93.25C106.576 93.2699 106.889 93.3793 107.204 93.5781C107.519 93.777 107.782 94.062 107.994 94.4332C108.206 94.8045 108.312 95.2585 108.312 95.7955C108.312 96.3059 108.196 96.7649 107.964 97.1726C107.732 97.5803 107.366 97.9034 106.866 98.142C106.365 98.3807 105.714 98.5 104.912 98.5H101.233ZM102.466 97.4062H104.912C105.717 97.4062 106.289 97.2505 106.627 96.9389C106.969 96.6241 107.139 96.2429 107.139 95.7955C107.139 95.4508 107.051 95.1326 106.876 94.8409C106.7 94.5459 106.45 94.3106 106.125 94.1349C105.8 93.956 105.416 93.8665 104.972 93.8665H102.466V97.4062ZM102.466 92.7926H104.753C105.124 92.7926 105.459 92.7197 105.757 92.5739C106.059 92.428 106.297 92.2225 106.473 91.9574C106.652 91.6922 106.741 91.3807 106.741 91.0227C106.741 90.5753 106.586 90.1958 106.274 89.8842C105.963 89.5694 105.469 89.4119 104.793 89.4119H102.466V92.7926ZM113.282 98.6591C112.566 98.6591 111.949 98.4901 111.432 98.152C110.915 97.8139 110.517 97.3482 110.239 96.755C109.961 96.1617 109.821 95.4839 109.821 94.7216C109.821 93.946 109.964 93.2616 110.249 92.6683C110.537 92.0717 110.938 91.6061 111.452 91.2713C111.969 90.9332 112.572 90.7642 113.262 90.7642C113.799 90.7642 114.283 90.8636 114.713 91.0625C115.144 91.2614 115.497 91.5398 115.772 91.8977C116.047 92.2557 116.218 92.6733 116.284 93.1506H115.111C115.022 92.8026 114.823 92.4943 114.515 92.2259C114.21 91.9541 113.799 91.8182 113.282 91.8182C112.824 91.8182 112.423 91.9375 112.078 92.1761C111.737 92.4115 111.47 92.7446 111.278 93.1754C111.089 93.603 110.995 94.1051 110.995 94.6818C110.995 95.2718 111.087 95.7855 111.273 96.223C111.462 96.6605 111.727 97.0002 112.069 97.2422C112.413 97.4841 112.818 97.6051 113.282 97.6051C113.587 97.6051 113.863 97.5521 114.112 97.446C114.36 97.34 114.571 97.1875 114.743 96.9886C114.916 96.7898 115.038 96.5511 115.111 96.2727H116.284C116.218 96.7235 116.054 97.1295 115.792 97.4908C115.534 97.8487 115.191 98.1338 114.763 98.3459C114.339 98.5547 113.845 98.6591 113.282 98.6591ZM121.201 98.6591C120.466 98.6591 119.831 98.4967 119.297 98.1719C118.767 97.8438 118.358 97.3864 118.069 96.7997C117.784 96.2098 117.642 95.5237 117.642 94.7415C117.642 93.9593 117.784 93.2699 118.069 92.6733C118.358 92.0734 118.759 91.6061 119.272 91.2713C119.789 90.9332 120.393 90.7642 121.082 90.7642C121.48 90.7642 121.873 90.8305 122.26 90.9631C122.648 91.0956 123.001 91.3111 123.319 91.6094C123.637 91.9044 123.891 92.2955 124.08 92.7827C124.269 93.2699 124.363 93.8698 124.363 94.5824V95.0795H118.477V94.0653H123.17C123.17 93.6345 123.084 93.25 122.912 92.9119C122.743 92.5739 122.501 92.3071 122.186 92.1115C121.874 91.916 121.506 91.8182 121.082 91.8182C120.615 91.8182 120.21 91.9342 119.869 92.1662C119.531 92.3949 119.271 92.6932 119.088 93.0611C118.906 93.429 118.815 93.8234 118.815 94.2443V94.9205C118.815 95.4972 118.914 95.986 119.113 96.3871C119.315 96.7848 119.596 97.0881 119.953 97.2969C120.311 97.5024 120.727 97.6051 121.201 97.6051C121.51 97.6051 121.788 97.562 122.037 97.4759C122.288 97.3864 122.506 97.2538 122.688 97.0781C122.87 96.8991 123.011 96.6771 123.11 96.4119L124.244 96.7301C124.125 97.1146 123.924 97.4527 123.642 97.7443C123.361 98.0327 123.013 98.258 122.598 98.4205C122.184 98.5795 121.718 98.6591 121.201 98.6591ZM130.861 90.8636V91.9574H127.321V98.5H126.148V90.8636H130.861ZM135.28 98.6591C134.59 98.6591 133.985 98.495 133.465 98.1669C132.948 97.8388 132.544 97.3797 132.252 96.7898C131.964 96.1998 131.819 95.5104 131.819 94.7216C131.819 93.9261 131.964 93.2318 132.252 92.6385C132.544 92.0452 132.948 91.5845 133.465 91.2564C133.985 90.9283 134.59 90.7642 135.28 90.7642C135.969 90.7642 136.572 90.9283 137.089 91.2564C137.61 91.5845 138.014 92.0452 138.302 92.6385C138.594 93.2318 138.74 93.9261 138.74 94.7216C138.74 95.5104 138.594 96.1998 138.302 96.7898C138.014 97.3797 137.61 97.8388 137.089 98.1669C136.572 98.495 135.969 98.6591 135.28 98.6591ZM135.28 97.6051C135.803 97.6051 136.234 97.4709 136.572 97.2024C136.91 96.9339 137.161 96.581 137.323 96.1435C137.485 95.706 137.567 95.232 137.567 94.7216C137.567 94.2112 137.485 93.7356 137.323 93.2947C137.161 92.8539 136.91 92.4976 136.572 92.2259C136.234 91.9541 135.803 91.8182 135.28 91.8182C134.756 91.8182 134.325 91.9541 133.987 92.2259C133.649 92.4976 133.399 92.8539 133.236 93.2947C133.074 93.7356 132.993 94.2112 132.993 94.7216C132.993 95.232 133.074 95.706 133.236 96.1435C133.399 96.581 133.649 96.9339 133.987 97.2024C134.325 97.4709 134.756 97.6051 135.28 97.6051Z" fill="#8F9CAC"/>
          <path d="M119.996 137.011C118.041 137.004 116.359 136.523 114.95 135.568C113.549 134.614 112.469 133.231 111.712 131.42C110.962 129.61 110.59 127.432 110.598 124.886C110.598 122.348 110.973 120.186 111.723 118.398C112.481 116.61 113.56 115.25 114.962 114.318C116.371 113.379 118.049 112.909 119.996 112.909C121.943 112.909 123.617 113.379 125.018 114.318C126.428 115.258 127.511 116.621 128.268 118.409C129.026 120.189 129.401 122.348 129.393 124.886C129.393 127.439 129.015 129.621 128.257 131.432C127.507 133.242 126.431 134.625 125.03 135.58C123.628 136.534 121.95 137.011 119.996 137.011ZM119.996 132.932C121.329 132.932 122.393 132.261 123.189 130.92C123.984 129.58 124.378 127.568 124.371 124.886C124.371 123.121 124.189 121.652 123.825 120.477C123.469 119.303 122.962 118.42 122.303 117.83C121.651 117.239 120.882 116.943 119.996 116.943C118.67 116.943 117.609 117.606 116.814 118.932C116.018 120.258 115.617 122.242 115.609 124.886C115.609 126.674 115.787 128.167 116.143 129.364C116.507 130.553 117.018 131.447 117.678 132.045C118.337 132.636 119.109 132.932 119.996 132.932Z" fill="#8F9CAC"/>
        </svg>
      </div>
    </div>
  </div>
</template>
<script setup>
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {formatNum} from "@/utils";


const props = defineProps({
  items: [Object, Array],
  total: Number,
})

const data = [...props.items].sort((a, b) => {
  // Если один из элементов - "Другие", он всегда идет в конец
  if (a.title === "Другие") return 1;
  if (b.title === "Другие") return -1;
  // Остальные сортируем по убыванию count
  return b.count - a.count;
})

const pastelColors = [
  "#637DF3", "#8BC7F0", "#8660EB", "#90EDB0",
  "#EFA657", "#F08BE6", "#E4E7EE"
];

let graphData = computed(() => {
  let graph = {
    labels: [],
    datasets: [{
      data: [],
      backgroundColor: [],
      hoverOffset: 4
    }]
  }


  data?.forEach((el, index) => {
    graph.labels.push(el.title)
    graph.datasets[0].data.push(el.count)
    graph.datasets[0].backgroundColor.push(pastelColors[index])
  })
  return graph
})

const getBgColor = (title) => {
  if(graphData.value?.labels?.indexOf(title)){
    return graphData.value?.datasets[0].backgroundColor[graphData.value?.labels?.indexOf(title)]
        ? graphData.value?.datasets[0].backgroundColor[graphData.value?.labels?.indexOf(title)]
        : "#637DF3"
  }
  return '#637DF3'
}

const getGraph = () => {
  if (doughnutChart.value) {
    new Chart(doughnutChart.value.getContext('2d'), {
      type: 'doughnut',
      data: graphData.value,
      options: {
        spacing: 7 ,
        borderRadius: 8,
        cutout: '80%',
        responsive: true,
        plugins: {
          legend: {
            display: false,
            position: 'left',
          },
          tooltip: {
            enabled: false // Отключает все tooltip'ы
          },
        }
      }
    });
  }
}

const route = useRoute();
const doughnutChart = ref(null);
onMounted(async () => {
  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.9/dist/chart.umd.min.js';
  script.onload = () => {
    getGraph()
  };
  await document.head.appendChild(script);


});
</script>
<style lang="scss" scoped>
.graph {
  background-color: white;
  border-radius: 16px;
  padding: 24px 24px  10px 24px;
  height: 441px;

  &__title {
    font-weight: 600;
    font-size: 20px;
    color: #1E3959;
  }

  &__content {
    display: flex;
  }

  &__legend {
    width: 517px;
    font-size: 14px;
    color: $dark-blue;
    margin-top: 8px;
    margin-bottom: 20px;

    .item {
      margin-top: 30px;
    }

    .title {
      margin-bottom: -10px;
    }

    .bg {
      border-radius: 50%;
      width: 12px;
      height: 12px;
      margin-top: 2px;
      margin-right: 8px;
    }
  }

  &__graph {
    height: 240px;
    margin-top: 83px;
    margin-left: 32px;
    position: relative;
  }

  &__total {
    position: absolute;
    top: 92px;
    left: 100px;

    .title {
      font-size: 14px;
      color: $gray;
      text-align: center;
      margin-bottom: 4px;
    }
    .count {
      font-weight: 700;
      font-size: 32px;
      text-align: center;
      color: $grey-text;
    }
  }

  .no-data {
    height: 352px;
    width: 100%;
    color: $gray;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 20px;
    text-align: center;
    border: 1px solid rgba(228, 231, 238, 1);
    border-radius: 12px;
    margin-top: 16px;
  }
}
</style>